import React, { useEffect, useState } from 'react';
import { Form, Button, Row, Col, Image, Card, Container } from 'react-bootstrap';
import faceAvatar from '../../resource/img/faceAvatar.png';
import ModalEditInfo from '../../components/ModalEditInfo/ModalEditInfo';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';

const AdminInfo = () => {
    const admin = useSelector(state => state.admin);
    const [data, setData] = useState({});
    const [isShowUpdateModal, setIsShowUpdateModal] = useState(false);

    useEffect(() => {
        if (admin && admin.adminData) {
            setData(admin.adminData);
        } else if (admin && admin.userData && admin.userData.userData) {
            setData(admin.userData.userData);
        } else {
            setData({});
        }
    }, [admin]);

    const convertToDateInputFormat = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        } catch {
            return '';
        }
    };

    return (
        <div className="admin-info-page bg-light py-5 min-vh-100">
            <Helmet>
                <title>Thông Tin Cá Nhân - SmartPark Admin</title>
            </Helmet>

            <Container>
                <Card className="border-0 shadow-sm rounded-4 overflow-hidden max-width-900 mx-auto">
                    <Card.Header className="bg-primary text-white p-4">
                        <div className="d-flex align-items-center gap-3">
                            <div className="rounded-circle bg-white text-primary d-flex align-items-center justify-content-center fw-bold fs-3 shadow-sm" style={{ width: '60px', height: '60px' }}>
                                {(data?.name || 'A').charAt(0).toUpperCase()}
                            </div>
                            <div>
                                <h4 className="fw-bold mb-1 text-white">{data?.name || 'Quản trị viên'}</h4>
                                <p className="mb-0 text-white-50 small">Mã hệ thống: <span className="font-monospace fw-bold text-white">{data?.adminCode || 'N/A'}</span></p>
                            </div>
                        </div>
                    </Card.Header>

                    <Card.Body className="p-4 bg-white">
                        <h6 className="fw-bold text-dark mb-4 border-bottom pb-2">
                            <i className="bi bi-person-lines-fill text-primary me-2"></i> Chi Tiết Hồ Sơ Quản Trị Viên
                        </h6>

                        <Row className="g-3">
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-secondary fw-semibold">Mã quản trị viên</Form.Label>
                                    <Form.Control type="text" className="bg-light font-monospace fw-bold" value={data?.adminCode || ''} readOnly />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-secondary fw-semibold">Họ và tên</Form.Label>
                                    <Form.Control type="text" className="bg-light fw-semibold" value={data?.name || ''} readOnly />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-secondary fw-semibold">Số điện thoại</Form.Label>
                                    <Form.Control type="text" className="bg-light" value={data?.phoneNumber || 'Chưa cập nhật'} readOnly />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-secondary fw-semibold">Email liên hệ</Form.Label>
                                    <Form.Control type="text" className="bg-light" value={data?.email || 'Chưa cập nhật'} readOnly />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-secondary fw-semibold">Giới tính</Form.Label>
                                    <Form.Control type="text" className="bg-light" value={data?.gender === true ? 'Nam' : 'Nữ'} readOnly />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-secondary fw-semibold">Ngày sinh</Form.Label>
                                    <Form.Control type="text" className="bg-light" value={data?.dateOfBirth ? convertToDateInputFormat(data.dateOfBirth) : 'Chưa cập nhật'} readOnly />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-secondary fw-semibold">Địa chỉ</Form.Label>
                                    <Form.Control type="text" className="bg-light" value={data?.address || 'TP. Hồ Chí Minh'} readOnly />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-secondary fw-semibold">Chức vụ</Form.Label>
                                    <Form.Control type="text" className="bg-light fw-bold text-success" value={data?.role || 'Quản trị viên'} readOnly />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="d-flex justify-content-end mt-4 pt-3 border-top">
                            <Button
                                variant="primary"
                                className="rounded-3 px-4 py-2 fw-semibold d-flex align-items-center gap-2 shadow-sm"
                                onClick={() => setIsShowUpdateModal(true)}
                            >
                                <i className="bi bi-pencil-square"></i>
                                <span>Chỉnh sửa thông tin</span>
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            </Container>

            <ModalEditInfo
                isShow={isShowUpdateModal}
                onClose={() => setIsShowUpdateModal(false)}
                dataModalFromParent={data}
            />
        </div>
    );
};

export default AdminInfo;